import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  selectIsLoading,
  selectUserData,
  setIsLoading,
} from "../../../../features/userSlice";
import BusinessLeaderDashboard from "../../../../components/AssetManagement/Overview/BusinessLeaderDashboard/BusinessLeaderDashboard";
import { CheckPermissions } from "../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import Page404 from "../../../../components/Page404/Page403";
import { QueryIDsBusinessLeaderDashBoard } from "./logic/QueryIDsBusinessLeaderDashBoard";
import { trackPromise } from "react-promise-tracker";
import { buiDashboardEndPointLogic } from "../../../../logic/AssetManagement/overview/BusinessLeaderDashboard/buiDashboardEndPointLogic";
import store from "../../../../store";
import SimpleBackdrop from "../../../../components/BackDrop/BackDrop";
import { useSearchParams } from "react-router-dom";

function BusinessLeaderDashboardScreen(userToken: any) {
  const oauthTokenHeader = userToken?.userToken;
  const isLoading = useSelector(selectIsLoading);
  const Websiteresponse = userToken?.response;
  const userData = useSelector(selectUserData);
  const [searchParams] = useSearchParams();

  // values fom business leader slice
  const {
    selectedSharedUidBui,
    selectedDimensions,
    selectedType,
    selectedStartDate,
    selectedEndDate,
    selectedAll,
  } = useSelector((state: any) => state?.businessLeaderDashBoard);

  const savedUid = selectedSharedUidBui;
  const savedDimensions = selectedDimensions;
  const savedType = selectedType;
  const savedStartDate = selectedStartDate;
  const savedEndDate = selectedEndDate;
  const savedSelectedAll = selectedAll;

  // states that will hold the data for each section
  const [highLevelTargetActualData, setHighLevelTargetActualData] = useState(
    []
  ) as any;
  const [lastMonthTargetVsActualData, setLastMonthTargetVsActualData] =
    useState([]) as any;
  const [last7DaysSince2DaysAgoData, setLast7DaysSince2DaysAgoData] = useState(
    []
  ) as any;
  const [mtdQftdBudgetControlIdData, setMtdQftdBudgetControlIdData] = useState(
    []
  ) as any;
  const [
    conversionLoadingPercLast14DaysData,
    setConversionLoadingPercLast14DaysData,
  ] = useState([]) as any;

  // Query IDs for each call
  const targetVsActualPRId = QueryIDsBusinessLeaderDashBoard.targetVsActualPRId;
  const lastMonthTargetVsActualId =
    QueryIDsBusinessLeaderDashBoard.lastMonthTargetVsActualId;
  const last7DaysSince2DaysAgoId =
    QueryIDsBusinessLeaderDashBoard.last7DaysSince2DaysAgoId;
  const mtdQftdBudgetControlId =
    QueryIDsBusinessLeaderDashBoard.mtdQftdBudgetControlId;
  const conversionLoadingPercLast14DaysId =
    QueryIDsBusinessLeaderDashBoard.conversionLoadingPercLast14DaysId;

  const hasViewBusinessLeaderPermission = CheckPermissions(
    userData?.data?.products?.assets,
    "overview",
    "view_business_leader_dashboard"
  );

  // eslint-disable-next-line
  const siteOptions =
    Websiteresponse?.website_permissions?.map((siteObj: any) => {
      const uid = Object.keys(siteObj)[0]; // UID of the site
      const siteName = siteObj[uid].ui_site_name; // Site name
      const dimensions = siteObj[uid]?.dimensions; // Site name
      return { uid, siteName, dimensions }; // Return as an object with uid and siteName
    }) || [];

  useEffect(() => {
    if (
      searchParams.get("selectedSharedUids") &&
      searchParams.get("selectedDimension") &&
      searchParams.get("selectedPeriod") &&
      searchParams.get("selectedType") &&
      searchParams.get("selectedInterval")
    ) {
      store.dispatch(setIsLoading(true));
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (searchParams?.size === 0) {
      store.dispatch(setIsLoading(false));
    }
  }, [searchParams]);

  const getlastMonthTargetVsActualData = async () => {
    try {
      store.dispatch(setIsLoading(true));
      if (hasViewBusinessLeaderPermission) {
        /// send to get data with targetVsActualPRId
        await buiDashboardEndPointLogic.getBuiDashboardData_lastMonthTarget(
          oauthTokenHeader,
          savedUid,
          lastMonthTargetVsActualId,
          trackPromise,
          setLastMonthTargetVsActualData,
          savedDimensions,
          savedType,
          savedSelectedAll,
          savedStartDate,
          savedEndDate
        );
      } else {
        throw new Error("User doesn't have permissions to get data");
      }
    } catch (error: any) {
      console.error("Error getting BUI dashboard data", error);
    } finally {
      store.dispatch(setIsLoading(false));
    }
  };

  const getlast7DaysSince2DaysAgoData = async () => {
    try {
      store.dispatch(setIsLoading(true));
      if (hasViewBusinessLeaderPermission) {
        /// send to get data with targetVsActualPRId
        await buiDashboardEndPointLogic.getBuiDashboardData_last7Days(
          oauthTokenHeader,
          savedUid,
          last7DaysSince2DaysAgoId,
          trackPromise,
          setLast7DaysSince2DaysAgoData,
          savedDimensions,
          savedType,
          savedSelectedAll,
          savedStartDate,
          savedEndDate
        );
      } else {
        throw new Error("User doesn't have permissions to get data");
      }
    } catch (error: any) {
      console.error("Error getting BUI dashboard data", error);
    } finally {
      store.dispatch(setIsLoading(false));
    }
  };

  const getConversionLoadingPercLast14DaysData = async () => {
    try {
      store.dispatch(setIsLoading(true));
      if (hasViewBusinessLeaderPermission) {
        /// send to get data with targetVsActualPRId
        await buiDashboardEndPointLogic.getBuiDashboardData_conversionLoading(
          oauthTokenHeader,
          savedUid,
          conversionLoadingPercLast14DaysId,
          trackPromise,
          setConversionLoadingPercLast14DaysData,
          savedDimensions,
          savedType,
          savedSelectedAll,
          savedStartDate,
          savedEndDate
        );
      } else {
        throw new Error("User doesn't have permissions to get data");
      }
    } catch (error: any) {
      console.error("Error getting BUI dashboard data", error);
    } finally {
      store.dispatch(setIsLoading(false));
    }
  };

  const getmtdQftdBudgetControlIdData = async () => {
    try {
      store.dispatch(setIsLoading(true));
      if (hasViewBusinessLeaderPermission) {
        /// send to get data with targetVsActualPRId
        await buiDashboardEndPointLogic.getBuiDashboardData_mtdQftd(
          oauthTokenHeader,
          savedUid,
          mtdQftdBudgetControlId,
          trackPromise,
          setMtdQftdBudgetControlIdData,
          savedDimensions,
          savedType,
          savedSelectedAll,
          savedStartDate,
          savedEndDate
        );
      } else {
        throw new Error("User doesn't have permissions to get data");
      }
    } catch (error: any) {
      console.error("Error getting BUI dashboard data", error);
    } finally {
      store.dispatch(setIsLoading(false));
    }
  };

  const getHighLevelTargetVsActualData = async (
    selectedSharedUid: string[],
    startDate: string,
    endDate: string,
    daysLeft: string,
    dimensions: string[],
    type: string,
    selectedAll: boolean,
    period: string,
    interval: string
  ) => {
    try {
      store.dispatch(setIsLoading(true));
      if (hasViewBusinessLeaderPermission) {
        /// send to get data with targetVsActualPRId
        await buiDashboardEndPointLogic.getBuiDashboardData(
          oauthTokenHeader,
          selectedSharedUid,
          targetVsActualPRId,
          trackPromise,
          setHighLevelTargetActualData,
          dimensions,
          type,
          selectedAll,
          startDate,
          endDate,
          period,
          interval,
          daysLeft
        );
      } else {
        throw new Error("User doesn't have permissions to get data");
      }
    } catch (error: any) {
      console.error("Error getting BUI dashboard data", error);
    } finally {
      store.dispatch(setIsLoading(false));
    }
  };

  const getAllDimesnionsForViewOrganizationalSummary = async (
    setViewOrganizationalSummary: any
  ) => {
    try {
      const isUserHasViewOrganizationalSummary = CheckPermissions(
        // check if user has view_organizational_summary
        userData?.data?.products?.assets,
        "overview",
        "view_organizational_summary"
      );
      if (isUserHasViewOrganizationalSummary) {
        /// send to get all webistes
        await buiDashboardEndPointLogic.getAllDimesnionsForViewOrganizationalSummary(
          oauthTokenHeader,
          trackPromise,
          setViewOrganizationalSummary
        );
      } else {
        throw new Error("User doesn't have permissions to get data");
      }
    } catch (error: any) {
      console.error("Error getting BUI dashboard data", error);
    }
  };

  return (
    <>
      {isLoading && <SimpleBackdrop />}
      <>
        {hasViewBusinessLeaderPermission ? (
          <>
            <BusinessLeaderDashboard
              siteOptions={siteOptions}
              getAllDimesnionsForViewOrganizationalSummary={
                getAllDimesnionsForViewOrganizationalSummary
              }
              getHighLevelTargetVsActualData={getHighLevelTargetVsActualData}
              getlastMonthTargetVsActualData={getlastMonthTargetVsActualData}
              getlast7DaysSince2DaysAgoData={getlast7DaysSince2DaysAgoData}
              getmtdQftdBudgetControlIdData={getmtdQftdBudgetControlIdData}
              getConversionLoadingPercLast14DaysData={
                getConversionLoadingPercLast14DaysData
              }
              highLevelTargetActualData={highLevelTargetActualData}
              sethighLevelTargetActualData={setHighLevelTargetActualData}
              lastMonthTargetVsActualData={lastMonthTargetVsActualData}
              last7DaysSince2DaysAgoData={last7DaysSince2DaysAgoData}
              mtdQftdBudgetControlIdData={mtdQftdBudgetControlIdData}
              conversionLoadingPercLast14DaysData={
                conversionLoadingPercLast14DaysData
              }
            />
          </>
        ) : (
          <Page404 />
        )}
      </>
    </>
  );
}

export default BusinessLeaderDashboardScreen;
